<template>
  <div v-if="config" class="channel-switch" @click="handleChange">
    <img v-if="config.icon" class="icon" :src="config.icon" />
    <span class="title">{{ config.title }}</span>
    <span v-if="canSelect" class="select-tip"></span>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PayTypes, allChannels, IPayType } from '.';
export interface IConfig {
  title: string;
  icon: string;
}
@Component({})
export default class ChannelSwitch extends Vue {
  @Prop({ type: Boolean, default: true }) canSelect!: boolean;
  @Prop({ type: Object, require: true }) config!: IPayType;
  handleChange() {
    if (this.canSelect) {
      this.$emit('change');
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 166px;
  height: 56px;
  padding: 0 16px;
  background: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.13);
  .icon {
    width: 32px;
    height: 32px;
    margin-right: 7px;
    // border-radius: 50%;
  }
  .title {
    color: #3b3561;
    font-size: 20px;
  }
  .select-tip {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 15px;
    background: url('./assets/icon-arrow-up.svg') center/100% no-repeat,
      rgba(138, 134, 161, 0.25);
    border-radius: 50%;
  }
}
</style>